export const destinations = [
    {
      name: 'Lisboa',
      avgPrice: 150,
      co2: 80,
      tags: ['Food', 'Culture', 'Beach', 'Nightlife'],
      coords: [38.7169, -9.1399],
      isAlternative: false,
      image: '/img/lisboa.jpg'
    },
    {
      name: 'Barcelona',
      avgPrice: 140,
      co2: 75,
      tags: ['Food', 'Nature', 'Culture', 'Beach', 'Nightlife'],
      coords: [41.3851, 2.1734],
      isAlternative: false,
      image: '/img/barcelona.jpg'
    },
    {
      name: 'París',
      avgPrice: 180,
      co2: 100,
      tags: ['Culture', 'Food', 'Nightlife'],
      coords: [48.8566, 2.3522],
      isAlternative: false,
      image: '/img/paris.jpg'
    },
    {
      name: 'Ámsterdam',
      avgPrice: 200,
      co2: 110,
      tags: ['Culture', 'Nature', 'Nightlife'],
      coords: [52.3676, 4.9041],
      isAlternative: false,
      image: '/img/amsterdam.jpg'
    },
    {
      name: 'Budapest',
      avgPrice: 170,
      co2: 120,
      tags: ['Culture', 'Nature', 'Nightlife'],
      coords: [47.4979, 19.0402],
      isAlternative: false,
      image: '/img/budapest.jpg'
    },
    {
      name: 'Copenhague',
      avgPrice: 220,
      co2: 90,
      tags: ['Food', 'Nature', 'Nightlife'],
      coords: [55.6761, 12.5683],
      isAlternative: false,
      image: '/img/copenhague.jpg'
    },
    {
      name: 'Roma',
      avgPrice: 170,
      co2: 95,
      tags: ['Food', 'Culture', 'Nightlife'],
      coords: [41.9028, 12.4964],
      isAlternative: false,
      image: '/img/roma.jpg'
    },
    {
      name: 'Praga',
      avgPrice: 160,
      co2: 100,
      tags: ['Culture', 'Nature', 'Nightlife'],
      coords: [50.0755, 14.4378],
      isAlternative: false,
      image: '/img/praga.jpg'
    },
    {
      name: 'Dublín',
      avgPrice: 210,
      co2: 130,
      tags: ['Food', 'Nature', 'Nightlife'],
      coords: [53.3498, -6.2603],
      isAlternative: false,
      image: '/img/dublin.jpg'
    },
    {
      name: 'Atenas',
      avgPrice: 190,
      co2: 140,
      tags: ['Culture', 'Nature', 'Beach'],
      coords: [37.9838, 23.7275],
      isAlternative: false,
      image: '/img/atenas.jpg'
    },
    {
      name: 'Berlín',
      avgPrice: 160,
      co2: 110,
      tags: ['Culture', 'Food', 'Nightlife'],
      coords: [52.5200, 13.4050],
      isAlternative: false,
      image: '/img/berlin.jpg'
    },
    {
      name: 'Estocolmo',
      avgPrice: 230,
      co2: 150,
      tags: ['Nature', 'Culture'],
      coords: [59.3293, 18.0686],
      isAlternative: true,
      image: '/img/estocolmo.jpg'
    },
    {
      name: 'Dubrovnik',
      avgPrice: 210,
      co2: 135,
      tags: ['Culture', 'Beach'],
      coords: [42.6507, 18.0944],
      isAlternative: true,
      image: '/img/dubrovnik.jpg'
    },
    {
      name: 'Sevilla',
      avgPrice: 150,
      co2: 90,
      tags: ['Culture', 'Food', 'Beach', 'Nightlife'],
      coords: [37.3886, -5.9823],
      isAlternative: false,
      image: '/img/sevilla.jpg'
    },
    {
      name: 'Girona',
      avgPrice: 140,
      co2: 80,
      tags: ['Culture', 'Nature'],
      coords: [41.9794, 2.8214],
      isAlternative: false,
      image: '/img/girona.jpg'
    },
    {
      name: 'Reykjavík',
      avgPrice: 260,
      co2: 180,
      tags: ['Nature', 'Mountain'],
      coords: [64.1265, -21.8174],
      isAlternative: true,
      image: '/img/reykjavik.jpg'
    },
    {
      name: 'Belfast',
      avgPrice: 200,
      co2: 150,
      tags: ['Culture', 'Mountain'],
      coords: [54.5973, -5.9301],
      isAlternative: true,
      image: '/img/belfast.jpg'
    }
  ];